// extracted by mini-css-extract-plugin
export var container = "Content-module--container--3r1z5";
export var content = "Content-module--content--3ugra";